export default __webpack_public_path__ + "static/092-02189b913a932cea9b23e827e271dae5.jpg";